import React, { Component, PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { Map, List, fromJS } from 'immutable'
import { Popup, Loader, Menu } from 'semantic-ui-react'
import { updateInterviewStatus } from './actions'

export let statusList = {
  contacts_missing: 'Yhteystiedot puuttuu',
  uncertain: 'Epäselvä',
  expired: 'Vanhentunut',
  scheduling: 'Aikataulutuksessa',
  scheduled: 'Haastattelu sovittu',
  production: 'Materiaalit tuotannossa',
  approval: 'Hyväksynnässä',
  approved: 'Hyväksytty',
  published: 'Julkaistu dashboardilla',
}

export let statusColor = {
  contacts_missing: 'grey',
  uncertain: 'red',
  expired: 'red',
  scheduling: 'blue',
  scheduled: 'blue',
  production: 'blue',
  approval: 'purple',
  approved: 'purple',
  published: 'green',
}

function InterviewStatus(props) {
  let { interview, interviewStatus, dispatch } = props

  if (!Map.isMap(interview)) return null

  let info = interviewStatus.get(interview.get('id'), Map())
  let status = interview.get('status') || 'contacts_missing'
  let color = statusColor[status] || 'grey'

  let open = info.get('open', false)
  let loading = info.get('loading', false)
  let error = info.get('error', false)

  let popupContent = (
    <Menu loading={loading.toString()} vertical size="small">
      {Object.keys(statusList).map(k => {
        return (
          <Menu.Item
            name={statusList[k]}
            active={status === k}
            key={k}
            onClick={e => e.preventDefault() & dispatch(updateInterviewStatus(interview.get('id'), k))}
          />
        )
      })}
    </Menu>
  )

  let buttonClasses = ['tags-item', `tags-item--${color}`]

  return (
    <Popup
      trigger={<button className={buttonClasses.join(' ')}>{statusList[status]}</button>}
      content={popupContent}
      onOpen={() =>
        dispatch({
          type: 'INTERVIEW_STATUS_OPEN',
          interview_id: interview.get('id'),
        })
      }
      onClose={() =>
        dispatch({
          type: 'INTERVIEW_STATUS_CLOSE',
          interview_id: interview.get('id'),
        })
      }
      open={open}
      style={{ marginTop: 0, padding: 0, borderRadius: 0 }}
      on="click"
      position="bottom center"
    />
  )
}

export default connect(state => ({
  interviewStatus: state.interviewStatus,
}))(InterviewStatus)
